import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { formatDateTime } from '../../../../util/datetime'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { renderRoleName, renderTaskName } from '../../util/names'
import currentUserHasAccess from '../../../../util/widget-helper'
import { PROCESS_TASK_LIST } from '../../ui-definition/process-ui'

const TaskList = ({ processTaskList }) => {
    if (!currentUserHasAccess(PROCESS_TASK_LIST)) {
        return null
    }

    return (
        <ContentBox title="Task list">
            <Row>
                <Column size={12}>
                    <table className="default-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Created</th>
                                <th>Due</th>
                                <th>Closed</th>
                                <th>Status</th>
                                <th>Role</th>
                                <th>Finished by</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                processTaskList.map(task => {
                                    return (<tr
                                        key={task.id}
                                    >
                                        <td><Link to={'/task/detail/' + task.id}>{renderTaskName(task.name)}</Link></td>
                                        <td>{formatDateTime(task.created)}</td>
                                        <td>{formatDateTime(task.due)}</td>
                                        <td>{formatDateTime(task.finished)}</td>
                                        <td>{task.status}</td>
                                        <td>{renderRoleName(task.role)}</td>
                                        <td>{task.finishedByUserName}</td>
                                    </tr>)
                                })
                            }
                        </tbody>
                    </table>
                </Column>

            </Row>
        </ContentBox>
    )
}

TaskList.propTypes = {
    processTaskList: PropTypes.array.isRequired,
}

export default TaskList



// WEBPACK FOOTER //
// ./src/modules/process/component/instance-detail/TaskList.js